(function () {
    'use strict';
    var controllerId = 'operations';
    angular.module('app').controller(controllerId, ['$filter', '$q', '$state', 'common', 'swaggerService', operations]);

    function operations($filter, $q, $state, common, swaggerService) {
        var vm = this;
        vm.currentApi = null;
        vm.swaggerOperations = [];

        activate();
        function activate() {
            common.handleBusyState([getCurrentApiInfo(), getCurrentApiOperations()], controllerId);
        }

        //#region Private Methods
        function getCurrentApiInfo() {
            var deferred = $q.defer();
            if ($state.params && $state.params.apiId) {
                // Look for current api
                var getApiPromise = swaggerService.getApiList().then(function (apis) {
                    var apisSearchResult = $filter('filter')(apis, function (api) {
                        return api.id === $state.params.apiId;
                    });
                    if (apisSearchResult && apisSearchResult.length == 1)
                        vm.currentApi = apisSearchResult[0];
                    deferred.resolve(true);
                });
            }
            else
                deferred.resolve(false);

            return deferred.promise;
        }

        function getCurrentApiOperations() {
            var deferred = $q.defer();
            if ($state.params && $state.params.apiId) {
                // Look for current API operations
                var getOperationsPromise = swaggerService.getOperationsByApiId($state.params.apiId).then(function (swaggerOperation) {
                    vm.swaggerOperations = swaggerOperation;
                    deferred.resolve(true);
                });
            }
            else
                deferred.resolve(false);

            return deferred.promise;
        }
        //#endregion
    }
})();